import * as angular from "angular";
import {IController} from "angular";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import * as _ from "lodash";

export class ImportFileMappingPreviewComponent implements IController {
  schemaFields: any;
  previewRows: any;
  onDeleteRow: Function;
  onChangePreviewRows: Function;

  public schemaFieldsMap: {};

  constructor() {
  }

  $onInit() {
    this.schemaFieldsMap = {};
    this.schemaFields?.forEach((sf, index) => {
      this.schemaFieldsMap[sf.colIndex] = sf;
    })
  }

  setEvents() {
    const div1 = document.getElementById('import-file-upload-preview').querySelectorAll(".import-file-upload-preview-header")[0];
    const div2 = document.getElementById('import-file-upload-preview').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  onChangeRowData(rowIndex, cellIndex, value) {
    const row = this.previewRows.find(r => r.rowIndex === rowIndex);
    row.cellValues[cellIndex].value = value;
    this.onChangePreviewRows({previewRows: this.previewRows})
  }

}

angular
  .module('bringoz.admin.commons')
  .component('importFileUploadPreview', {
    bindings: {
      schemaFields: '<',
      previewRows: '<',
      onDeleteRow: '&',
      onChangePreviewRows: '&'
    },
    templateUrl: 'app/modules/commons/components/import-file-upload-preview/import-file-upload-preview.html',
    controller: ImportFileMappingPreviewComponent
  });
